


































import { defineComponent } from '@nuxtjs/composition-api';

import BiuraBreadcrumbs from '~/components/biura/components/biura-breadcrumbs.vue';
import BiuraLista from '~/components/biura/components/biura-lista.vue';
import Wyszukiwarka from '~/components/biura/components/wyszukiwarka.vue';
import useBiuraGlownaService from '~/components/biura/services/useBiuraGlownaService';
// import Map from '~/components/map/map.vue';

export default defineComponent({
  components: {
    Wyszukiwarka,
    BiuraLista,
    BiuraBreadcrumbs,
    Map: () => import('~/components/map/map.vue'),
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setup(props, { refs }) {
    return {
      ...useBiuraGlownaService(),
    };
  },
  head() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.metaTags as any;
  },
});
